export enum TypeParams {
    ID = 'id',
    /** Ids de campaña separados por coma (`/ranch/list/?years=2022,2023`). */
    YEARS = 'years',
    /** Ids de departamento separados por coma (`/ranch/list/?departments=3,7`). */
    DEPARTMENTS = 'departments',
    /** Ids de tipo de cultivo separados por coma (`/ranch/list/?crop_types=1,4`). */
    CROP_TYPES = 'crop_types',
    /** Id de la aseguradora activa (`/ranch/list/` y sus endpoints de opciones). `0` es válido. */
    CUSTOMER = 'customer',
    /** `id` que devuelve `GET /ranch/` (no el `:id` de la URL); va en `/ranch/list/` y `/ranch/list/options/`. */
    RANCH_ID = 'ranch_id',
    DATE_FROM = 'date_from',
    DATE_TO = 'date_to'
}
